import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

export default function MentorHeader({ userRole, setIsLoginOpen, setIsSignupOpen, logout }) {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const [step, setStep] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setStep((p) => (p + 1) % 5), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const menu = [
    'Home',
    'Course Resources',
    'Feedback & Reports',
    'My Mentees',
    'Discussion Threads',
    'Get Self Assessment',
    'Dashboard'
  ];

  const go = (m) => {
    setOpen(false);
    switch (m) {
      case 'Home':
        if (userRole === 'mentor') nav('/home');
        else nav('/');
        break;
      case 'Dashboard':
        nav('/mentor/dashboard');
        break;
      case 'Course Resources':
        nav('/mentor/courses-resources');
        break;
      case 'Feedback & Reports':
        nav('/mentor/feedback-reports');
        break;
      case 'My Mentees':
        nav('/mentor/my-mentees');
        break;
      case 'Discussion Threads':
        nav('/mentor/discussion-threads');
        break;
      case 'Get Self Assessment':
        window.open(
          'https://ai-microapp-template-development.streamlit.app/?template=Career+Advisor',
          '_blank'
        );
        break;
      default:
        break;
    }
  };

  return (
    <>
      <header className="navbar-container">
        <div className="top-row">
          <div
            className="logo"
            onClick={() => {
              if (userRole === 'mentor') nav('/home');
              else nav('/');
            }}
          >
            <img
              src="/footer/Robokalam Logo Real header 1.png"
              alt="Robokalam Logo"
              className="logo"
            />
          </div>

          <div className="top-center">
            <nav className="menu">
              {menu.map((m) => (
                <button
                  key={m}
                  onClick={() => go(m)}
                  style={
                    m === 'Get Self Assessment'
                      ? { backgroundColor: '#ff6600', color: '#ffffff' }
                      : {}
                  }
                >
                  {m}
                </button>
              ))}
            </nav>

          </div>

          <div className="top-actions">
            {!userRole ? (
              <>
                <button className="login-btn" onClick={() => nav('/loginform')}>Login →</button>
                <button className="login-btn" onClick={() => nav('/signupform')}>Sign up →</button>
              </>
            ) : (
              <button className="login-btn" onClick={logout}>
                Logout →
              </button>
            )}
          </div>

          <div className="hamburger" onClick={() => setOpen(true)}>
            ☰
          </div>
        </div>

        <div className="bottom-row">
          <h1 className="title">
            KodeZ –
            {step >= 1 && <span className="animated-word"> Learn.</span>}
            {step >= 2 && <span className="animated-word"> Launch.</span>}
            {step >= 3 && <span className="animated-word"> Lead.</span>}
          </h1>
        </div>
      </header>

      {open && (
        <div className="side-popup-overlay">
          <div className="side-popup" ref={ref}>
            {menu.map((m) => (
              <button
                key={m}
                onClick={() => go(m)}
                style={
                  m === 'Get Self Assessment'
                    ? { backgroundColor: '#ff6600', color: '#ffffff' }
                    : {}
                }
              >
                {m}
              </button>
            ))}
            {userRole ? (
              <button onClick={logout}>Logout</button>
            ) : (
              <>
                <button
                  onClick={() => {
                    setIsLoginOpen(true);
                    setOpen(false);
                  }}
                >
                  Login
                </button>
                <button
                  onClick={() => {
                    setIsSignupOpen(true);
                    setOpen(false);
                  }}
                >
                  Sign up
                </button>
              </>
            )}
          </div>

        </div>
      )}
    </>
  );
}
